var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgInsurancetools(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 7481",
    d: "M0 0h24v24H0z",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 7482",
    d: "M14.215 7.125l3.592-3.592a.1.1 0 00-.03-.158 5.677 5.677 0 00-6.225 1.174 5.512 5.512 0 00-1.288 5.926L3.5 17.238a2.278 2.278 0 000 3.221h0a2.278 2.278 0 003.221 0l6.806-6.806a5.512 5.512 0 005.926-1.288 5.542 5.542 0 001.177-6.232.1.1 0 00-.157-.028L16.792 9.7h0L15.5 8.415l-1.289-1.29z",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })));
}

export default SvgInsurancetools;


//////////////////
// WEBPACK FOOTER
// ./src/icons/insurance tools.svg
// module id = 894
// module chunks = 101